<template>
    <div class="container-fluid min-vh-100 p-2">
  
  <div class="row g-3 mb-5">
    <div class="col-12 col-md-6 col-lg-3">
      <div class="card border shadow rounded-4">
        <div class="card-body d-flex justify-content-between align-items-center p-3">
          <div>
            <p class="text-dark small mb-1 opacity-75">Today's Total Cases</p>
            <h3 class="text-primary fw-bold mb-0">0</h3>
          </div>
          <div class="bg-white bg-opacity-25 rounded p-2">
            <i class="bi bi-clock text-dark fs-4"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-3">
      <div class="card border shadow rounded-4" >
        <div class="card-body d-flex justify-content-between align-items-center p-3">
          <div>
            <p class="text-dark small mb-1 opacity-75">Current Month Cases</p>
            <h3 class="text-primary fw-bold mb-0">1</h3>
          </div>
          <div class="bg-white bg-opacity-25 rounded p-2">
            <i class="bi bi-calendar-event text-dark fs-4"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-3">
      <div class="card border shadow rounded-4" >
        <div class="card-body d-flex justify-content-between align-items-center p-3">
          <div>
            <p class="text-dark small mb-1 opacity-75">Current Year Cases</p>
            <h3 class="text-primary fw-bold mb-0">32</h3>
          </div>
          <div class="bg-white bg-opacity-25 rounded p-2">
            <i class="bi bi-briefcase text-dark fs-4"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-3">
      <div class="card border shadow rounded-4">
        <div class="card-body d-flex justify-content-between align-items-center p-3">
          <div>
            <p class="text-dark small mb-1 opacity-75">Total Cases Imported</p>
            <h3 class="text-primary fw-bold mb-0">0</h3>
          </div>
          <div class="bg-white bg-opacity-25 rounded p-2">
            <i class="bi bi-box-arrow-right text-dark fs-4"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card border-0 shadow-lg rounded-4 overflow-hidden">
    <div class="card-header bg-white border-0 d-flex justify-content-end p-4">
      <button class="btn btn-dark rounded-pill px-4 btn-sm d-flex align-items-center shadow-sm bg-primary-blue">
        <span class="fw-bold">Overall Demographics</span>
      </button>
    </div>
    
    <div class="card-body p-4 text-center">
      <div id="chart-container" class="w-100" style="min-height: 400px;"></div>
    </div>
  </div>

</div>
</template>
<script>
/* eslint-disable */
import Highcharts from 'highcharts';

export default {
  name: 'DashboardView',
  data: () => ({
    // Use the hostname logic we established for domain-specific UI
    hostname: window.location.hostname, //
    
    // Top Statistics derived from your image
    topStats: [
      { title: "Today's Cases", value: 0, icon: "bi bi-clock" },
      { title: "Current Month Cases", value: 1, icon: "bi bi-calendar-event" },
      { title: "Current Year Cases", value: 32, icon: "bi bi-briefcase" },
      { title: "Total Cases Imported", value: 0, icon: "bi bi-box-arrow-right" }
    ],

    // Existing compliance data structures from your code
    compliance_tabs: [
      { id: "overview", name: "Overview" },
      { id: "onboarding", name: "Onboarding Compliance" },
      { id: "ongoing", name: "Ongoing Compliance" },
    ],
  }),

  mounted() {
    this.renderChart();
    this.filterComplianceTabs(); // Apply domain-specific tab logic
  },

  methods: {
    /**
     * Filters compliance tabs based on domain as previously requested
     */
    filterComplianceTabs() {
      if (this.hostname.includes('x-verdict')) {
        this.compliance_tabs = this.compliance_tabs.filter(tab => tab.id !== 'overview');
      }
    },

    /**
     * Generates the chart matching the "Reported Cases by Origin" UI
     */
    renderChart() {
      Highcharts.chart('chart-container', {
        chart: {
          type: 'column',
          backgroundColor: 'transparent',
          style: { fontFamily: 'inherit' }
        },
        title: {
          text: 'Reported Cases by Origin',
          style: { fontWeight: 'bold', fontSize: '18px' }
        },
        subtitle: {
          text: '01 Oct 2024 to 04 Feb 2026'
        },
        xAxis: {
          categories: ['Gauteng', 'Kwa-Zulu Natal', 'Limpopo'],
          gridLineWidth: 0
        },
        yAxis: {
          title: { text: 'Number of Cases' },
          min: 0,
          max: 15,
          tickInterval: 5
        },
        tooltip: { shared: true },
        plotOptions: {
          column: {
            borderRadius: 5,
            dataLabels: { enabled: true }
          }
        },
        series: [
          {
            name: '2025-2026',
            data: [12, 1, 0],
            color: '#84B440' // Bright blue from image
          },
          {
            name: '2024-2025',
            data: [6, 0, 1],
            color: '#0A3B34' // Deep purple from image
          },
          {
            name: 'Average',
            type: 'line',
            data: [9, 0.5, 0.5],
            color: '#00e676', // Green line from image
            marker: {
              lineWidth: 2,
              lineColor: '#00e676',
              fillColor: 'white'
            }
          }
        ],
        credits: { enabled: false }
      });
    }
  }
};</script>